import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import styles from "../../../../services/ServicesSections.module.scss";
// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
 
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Google Search Data & Covid19</h3>
          <p> 

          This post was inspired by <a href="https://onezero.medium.com/@patrickberlinquette">Patrick Berlinquette</a> in his medium post: <a href="https://onezero.medium.com/google-searches-reveal-covid-19-hot-spots-before-governments-do-b689b3008ac1">https://onezero.medium.com/google-searches-reveal-covid-19-hot-spots-before-governments-do-b689b3008ac1</a>. Thanks also to<a href="https://twitter.com/MicheleJKiss?s=20"> Michell Kiss</a> - who posted the above link on measureslack and hence was how we first found out about it! 😀 In the article Patrick described how he had been buying search terms related to "loss of smell" for the biggest 250 cities in the US since April 23. 
          <br /><br />
          The data was predictive of future outbreaks, increased searches for symptoms were closely followed by increased numbers of cases. Simple hey! Brilliant even... Here is a chart of all searches from the 250 most populated U.S. cities who has Googled “I can’t smell” since April 23 (taken from his medium post): 

          </p>


          </GridItem>
          <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-07-15-Covid19/patberg1-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
            </GridItem>
          </div>
          <GridItem xs={12} sm={8} md={8}>
          <p>
          <br />
          Using the above we decided to apply the same to the Australian context - especially in relation to the recent "Second Wave" outbreaks in Victoria - and potentially NSW. We really wanted to see if the Victorian situation would replicate elsewhere... we also wanted to see which particular neighbourhoods where at risk.
          <br /><br />
          You can see how things have been going recently in Sydney:
          </p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-07-15-Covid19/covidmap2-resize.webp"
                      alt="..."
                      className={imgClasses}
                    />
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>
          <p>

          
          <br /><br />
          Now a couple of things to point out before we go to our dashboard:
          <br /><br />
          <strong>1. These are not "heavily searched for terms".</strong> We understand that by releasing this approach, people without symptoms may be tempted to search for these terms and generate erroneous data. Theres nothing we can really do about that... So the integrity of the data can only really be   guaranteed for July8-(midday)July15.
          <br /><br />
          <strong>2. We have no prior data.</strong> So "how different" are these search trends to normal? For us thats impossible to know without that prior data. So to verfiy what we are getting all we can do is compare results to cases occuring on the ground. At time of wrigint theres has been an outbreak of over 30 people in Airds/Casula regins of NSW. Both of which show up very prominently in our data. You can draw your own conclusions... 
          <br /><br />
          <strong>3. Given the data is likely to be screwed for the next while - we may need to expand our search list into other covid-related symptoms.</strong> Look for a future update on this here.
          <br /><br />
          </p>
          <h3 className={classes.title}>The Data Studio report - click image below!!</h3>
          <p>To interact with the actual dashboard please click on the image below. (Note: Google Data Studio is stillincapable fo embeding a report that comtains google maps for some rreason... hence we are using the traditional link/not embed method :-)</p>

        </GridItem>

        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>
            <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-07-15-Covid19/covidmap2-resize.webp"
                      alt="..."
                      className={imgClasses}
                      href="https://datastudio.google.com/reporting/c4e3393f-7227-4bc3-8d7f-48caac26f75f"
                    />
                    
            </GridItem>
          </div>

          <GridItem xs={12} sm={8} md={8}>      
                <br></br>

                <p>Check out more about the awesome <a href="/services/data-studio-services">Data Studio Services</a> we offer!</p>


          </GridItem>


      </GridContainer>
    </div>

  );
}
